"use client";

import { useTranslations } from "next-intl";

import { Title } from "@/shared/components/title";
import { Subtitle } from "@/shared/components/subtitle";
import { Box } from "@/shared/components/box";
import { tp } from "@/shared/utils/typograf";

import SparkleHighlightIcon from "@/shared/icons/sparkle-highlight.svg";
import BoltIcon from "@/shared/icons/bolt.svg";
import ShieldCheckIcon from "@/shared/icons/shield-check.svg";

export const NextGeneration = () => {
  const t = useTranslations("nextGeneration");

  return (
    <div
      id="opportunities"
      className="section-container space-y-8 lg:space-y-13.5 scroll-mt-20 lg:scroll-mt-28"
    >
      <div className="space-y-4 text-center">
        <Title>{tp.execute(t("title"))}</Title>
        <Subtitle>{tp.execute(t("subtitle"))}</Subtitle>
      </div>
      <div className="grid gap-4 lg:grid-cols-3 lg:gap-6">
        <Box className="py-6 space-y-4">
          <SparkleHighlightIcon className="mx-auto size-12" />
          <div className="mx-auto max-w-71 space-y-2 text-center">
            <h5 className="text-xl leading-7 lg:text-2xl lg:leading-8 font-medium">
              {tp.execute(t("features.allInHand.title"))}
            </h5>
            <p className="text-[#7B7B87] text-base leading-6 lg:text-xl lg:leading-7">
              {tp.execute(t("features.allInHand.subtitle"))}
            </p>
          </div>
        </Box>
        <Box className="py-6 space-y-4">
          <BoltIcon className="mx-auto size-12" />
          <div className="mx-auto max-w-71 space-y-2 text-center">
            <h5 className="text-xl leading-7 lg:text-2xl lg:leading-8 font-medium">
              {tp.execute(t("features.borderlessTransfers.title"))}
            </h5>
            <p className="text-[#7B7B87] text-base leading-6 lg:text-xl lg:leading-7">
              {tp.execute(t("features.borderlessTransfers.subtitle"))}
            </p>
          </div>
        </Box>
        <Box className="py-6 space-y-4">
          <ShieldCheckIcon className="mx-auto size-12" />
          <div className="mx-auto max-w-71 space-y-2 text-center">
            <h5 className="text-xl leading-7 lg:text-2xl lg:leading-8 font-medium">
              {tp.execute(t("features.reliableProtection.title"))}
            </h5>
            <p className="text-[#7B7B87] text-base leading-6 lg:text-xl lg:leading-7">
              {tp.execute(t("features.reliableProtection.subtitle"))}
            </p>
          </div>
        </Box>
      </div>
    </div>
  );
};
